module.exports = __webpack_public_path__ + "static/17-df6c62033a0fa40d9e1549280361228b.jpeg";